export default "__VITE_ASSET__3dovXEkI__"